import {Icon} from '../atoms/Icon/Icon';
import {IconType} from '../atoms/Icon/IconType.enum';
import {Text} from '../atoms/Text/Text';
import {MobileLayoutViewerTitleHeaderProps} from './MobileLayoutViewerTitleHeaderProps.interface';

export function MobileLayoutViewerTitleHeader({
  title = '',
  onClickContentHome,
}: MobileLayoutViewerTitleHeaderProps) {
  return (
    <div className="flex h-mobile_header_height_px w-full items-center justify-between bg-theme-bg-base px-10pxr">
      <div className="mr-12pxr shrink-0">
        <Icon
          type={IconType.NavigationContentsHome}
          onClick={onClickContentHome}
        />
      </div>
      <div className="flex flex-1 items-center justify-start">
        <Text className="font-medium2-bold text-ellipsis break-all text-theme-solid-100 line-clamp-1">
          {title}
        </Text>
      </div>
    </div>
  );
}
